<ng-container *transloco="let convert;">
  @if (vm$ | async; as vm) {
    <div class="advanced_search_distance">
      <div class="advanced_search_distance__arrow"></div>
      <div [formGroup]="odometerForm" class="d-flex advanced_search_distance__input">
        <div class="form-group">
          <label id="advanced-search-distance-dropdown-label" class="text-uppercase" for="advanced-search-distance-raadius">
            {{convert('sellModule.manageInventory.advancedSearch.advancedSearchOdometer.labelOdometer')}}
          </label>
          <div class="control-wrapper">
            <input
              class="form-control"
              type="text"
              name="odometer-min"
              id="advanced-search-odometer-min"
              formControlName="min"
              aria-label="advanced-search-odometer-min"
              placeholder="Min"
              (input)="onInputChange($event)"
              />
          </div>
        </div>
        <div class="form-group d-flex flex-column px-2">
          <label class="text-uppercase">&nbsp;</label>
          <div class="d-flex align-items-center h-100">{{convert('sellModule.manageInventory.advancedSearch.advancedSearchOdometer.textTo')}}</div>
        </div>
        <div class="form-group">
          <label class="text-uppercase" for="advanced-search-distance-raadius">
            &nbsp;
          </label>
          <div class="control-wrapper">
            <input
              class="form-control"
              type="text"
              name="odometer-max"
              formControlName="max"
              id="advanced-search-odometer-max"
              aria-label="advanced-search-odometer-max"
              placeholder="Max"
              (input)="onInputChange($event)"
              />
          </div>
        </div>
      </div>
      <div class="advanced_search_distance--action_btn">
        <button class="btn btn-secondary advanced_search_distance--action_btn__close" (click)="close()">{{convert('common.btnClose')}}</button>
      </div>
    </div>
  }
</ng-container>
